import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';

export const editInput = <T>(
    input: GiftJson.Input<T>,
    changes: Partial<T>
): GiftJson.Input<T> => {
    return {
        ...input,
        value: {
            ...input.value,
            ...changes
        }
    };
};